import { Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';
import CookieConsentBanner from '../gdpr/CookieConsentBanner';
import PrivacyModal from '../gdpr/PrivacyModal';

/**
 * Layout principale per le pagine protette
 */
function MainLayout() {
  const { user } = useAuth();

  // Mostra modal privacy se utente autenticato ma non ha accettato
  const showPrivacyModal = user && user.privacyAccepted === false;

  return (
    <div 
      className="min-h-screen min-h-[100dvh] flex bg-background"
      style={{
        minHeight: '-webkit-fill-available',
      }}
    >
      {/* Sidebar */}
      <Sidebar />

      {/* Contenuto principale */}
      <div className="flex-1 flex flex-col min-h-screen min-h-[100dvh] md:ml-64 w-full overflow-x-hidden">
        {/* Header */}
        <Header />

        {/* Contenuto pagina */}
        <main 
          className="flex-1 p-3 pt-4 pb-6 sm:p-4 md:p-6 lg:p-8 overflow-x-hidden"
          style={{
            paddingBottom: 'max(1.5rem, env(safe-area-inset-bottom))',
            paddingLeft: 'max(0.75rem, env(safe-area-inset-left))',
            paddingRight: 'max(0.75rem, env(safe-area-inset-right))',
          }}
        >
          <Outlet />
        </main>

        {/* Footer */}
        <footer 
          className="p-3 sm:p-4 border-t border-border text-center text-xs sm:text-sm text-muted-foreground"
          style={{
            paddingBottom: 'max(1rem, env(safe-area-inset-bottom))',
          }}
        >
          <p>&copy; {new Date().getFullYear()} Portale Famiglia - Casa di Riposo</p>
        </footer>
      </div>

      {/* GDPR Components */}
      <CookieConsentBanner />
      <PrivacyModal open={showPrivacyModal} />
    </div>
  );
}

export default MainLayout;
